import 'aos/dist/aos.css';

import HomepageDeliveryIcon from '@/main/components/shared/icons/homepageDeliveryIcon';
import HomepageShopIcon from '@/main/components/shared/icons/homepageShopIcon';
import imageLine from '@/main/assets/images/homepage/line.png';
import image2 from '@/main/assets/images/homepage/shutterstock_1684264576.jpg';
import image1 from '@/main/assets/images/homepage/shutterstock_2261748231_right.jpg';
import image3 from '@/main/assets/images/homepage/shutterstock_2416299931.jpg';
import image4 from '@/main/assets/images/homepage/shutterstock_517813702.jpg';
import image5 from '@/main/assets/images/homepage/_ HP Elite Dragonfly.png';
import image6 from '@/main/assets/images/homepage/shutterstock_2284084849.jpg';
import { BaseDivHomePage } from '@/main/components/layouts/homepageLayout/styles';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { getTranslateByKey } from '@/main/services/utils';

import {
  HomepageElectronIcon,
  HomepageGearIcon,
  HomepageSecureIcon,
  HomepageShippingIcon,
  HomepageSuccessIcon,
  HomepageTargetIcon
} from '@/main/components/shared/icons';

import ButtonDemo from '../components/buttonDemo/buttonDemo';
import TextImage from '../components/textImage/textImage';
import CardCompanyType from './cardCompanyType/cardCompanyType';
import * as SHomepage from '../components/styles';
import * as S from './styles';

function HomepageScreen() {

  return (
    <S.Container>
      <SHomepage.FirstSection $backgroundImage={image1}>
        <S.AreaSectionLandingPage>
          <S.TitleLandingPage>
            <span data-aos='fade-up' data-aos-delay='100'>{getTranslateByKey('information.titleHomepage1')}</span>
            <span data-aos='fade-up' data-aos-delay='200'>{getTranslateByKey('information.titleHomepage2')}</span>
            <span data-aos='fade-up' data-aos-delay='300'>{getTranslateByKey('information.titleHomepage3')}</span>
            <span data-aos='fade-up' data-aos-delay='400'>{getTranslateByKey('information.titleHomepage4')}</span>
          </S.TitleLandingPage>
          <ButtonDemo data-aos='fade-up' data-aos-delay='500' />
        </S.AreaSectionLandingPage>
      </SHomepage.FirstSection>
      <TextImage
        idImage='id-image-2'
        icon={<HomepageGearIcon />}
        backgroundImage={image2}
        title={getTranslateByKey('information.profToProf')}
        description={getTranslateByKey('information.profToProfDescription')}
        positionImage="right"
        sizeText='medium'
        imageProps={{
          clipBorderImage: 'left',
          width: '650px',
          height: '500px'
        }}
      />
      <TextImage
        idImage='id-image-3'
        icon={<HomepageElectronIcon />}
        backgroundImage={image3}
        sizeText='medium'
        title={getTranslateByKey('information.iaHomepage')}
        description={getTranslateByKey('information.iaHomepageDescription')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'right',
          width: '650px',
          height: '500px'
        }}
      />
      <TextImage
        idImage='id-image-4'
        icon={<HomepageTargetIcon />}
        backgroundImage={image4}
        title={getTranslateByKey('information.precisionAndEfficiency')}
        description={getTranslateByKey('information.precisionAndEfficiencyDescription')}
        positionImage="right"
        sizeText='medium'
        imageProps={{
          clipBorderImage: 'bottom',
          width: '400px',
          height: '500px'
        }}
      />
      <BaseDivHomePage>
        <S.ImageLine src={imageLine} />
      </BaseDivHomePage>

      <TextImage
        idImage='id-image-5'
        icon={<HomepageSuccessIcon />}
        backgroundImage={image5}
        title={getTranslateByKey('information.plataformEndToEnd')}
        description={getTranslateByKey('information.plataformEndToEndDescription')}
        positionImage="left"
        sizeText='medium'
      />

      <TextImage
        idImage='id-image-6'
        icon={<HomepageSecureIcon />}
        backgroundImage={image6}
        title={getTranslateByKey("information.reliableAndSecure")}
        description={getTranslateByKey("information.reliableAndSecureDescription")}
        positionImage="right"
        sizeText='medium'
        imageProps={{
          clipBorderImage: 'bottom',
          width: '400px',
          height: '500px'
        }}
      />
      <S.AreaCardCompanyType>
        <CardCompanyType
          icon={<HomepageShippingIcon />}
          title={getTranslateByKey('information.homepageSuppliers')}
          description={getTranslateByKey('information.suppliersDescription')}
          linkButton={RoutesConstants.homepageSupplier}
          data-aos='fade-up'
        />
        <CardCompanyType
          icon={<HomepageShopIcon />}
          title={getTranslateByKey('information.bodyshops')}
          description={getTranslateByKey('information.bodyshopsDescription')}
          linkButton={RoutesConstants.homepageBodyshop}
          data-aos='fade-up'
          data-aos-delay='100'
        />
        <CardCompanyType
          icon={<HomepageDeliveryIcon />}
          title={getTranslateByKey('information.insurers')}
          description={getTranslateByKey('information.insurersDescription')}
          linkButton={RoutesConstants.homepageInsurer}
          data-aos='fade-up'
          data-aos-delay='200'
        />
      </S.AreaCardCompanyType>
    </S.Container>
  );
}

export default HomepageScreen;
